import { Navigate, Outlet } from "react-router-dom";
import { useSessionProbe } from "@flame/shared/auth";
import { Spinner } from "@flame/shared/ui";

/**
 * Guard for /totp/setup and /totp/verify in the LK.
 * Allows access when a valid LK session exists, even if TOTP is not yet verified.
 * Mirrors apps/admin/src/layout/RequireAdminPreTotp.tsx.
 */
export function RequireAuthPreTotp() {
  const { data: me, isLoading } = useSessionProbe();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!me) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
